<template>
    <div class="styled-options">
        <label v-if="label.length" class="styled-options__label">
            {{ label }}
        </label>

        <div class="styled-options__group">
            <template v-for="(option, loopIndex) in options">
                <div class="styled-options__option"
                     :class="{
                                 'styled-options__option--valid': valid,
                                 'styled-options__option--error': error,
                            }">

                    <input
                            :name="name"
                            class="styled-options__input"

                            :id="'opt-' + option.value"
                            v-model="internalValue"
                            @change="emit()"
                            :value="option.value"
                            type="radio"
                            v-validate="(loopIndex != 0) ? null : validation"
                    >

                    <label
                            class="styled-options__label"
                            :for="'opt-' + option.value"
                    >{{option.label}}</label>

                </div>
            </template>
        </div>
    </div>
</template>


<script>
  import mixins from "../mixins/InputMixins.js"


  import { mapActions } from 'vuex'
  import { mapGetters } from 'vuex'
  import { mapState } from 'vuex'


  export default {
    name: "StdOptions",
    inject: ['$validator'],
    props: {
      name: { type: String, default: "..." },
      value: { type: String, default: "" },
      label: { type: String, default: "" },
      validation: { type: String, default: "" },
      options: {
        type: Array, default: function () {
          return []
        }
      },
      type: { type: String, default: "checkbox" },
    },

    data() {
      return {
        internalValue: this.value
      }
    },

    methods: {

      inputId(option) {
        return this.name + '__' + option.value;
      },
      check(value) {
        this.value[value] = !this.value[value];
      },

      emit() {
        this.$emit('input', this.internalValue);
      },


      genericOptionClass: function (elementname, option) {
        var baseClasses = [this.type + '__' + elementname];

        /* split up classes in case there are multiple */
        if (this.fieldClass.length) {
          var fieldClasses = this.fieldClass.split(" ");
          var type = this.type;
          fieldClasses.forEach(function (val) {
            baseClasses.push(val + '__' + elementname);
            baseClasses.push(val + '-' + type + '__' + elementname);
          });
        }

        var stateClasses = []


        if (this.isActive(option)) {
          baseClasses.forEach(function (val) {
            stateClasses.push(val + "--active");
          });
        }

        if (this.disabled) {
          baseClasses.forEach(function (val) {
            stateClasses.push(val + "--disabled");
          });
        }

        var classes = baseClasses.concat(stateClasses);

        return classes.join(' ')

      },
      isActive: function (option) {
        return typeof(this.value) == "object" ? this.value.includes(option.value) : option.value == this.value;
      },

      optionInputClass: function (option) {
        return this.genericOptionClass("option-input", option);
      },
      optionLabelClass: function (option) {
        return this.genericOptionClass("option-label", option);
      }
    },
    computed: {
      error() {
        return this.errors.has(this.name) && !this.focus;
      },
      valid() {
        return !this.errors.has(this.name) && this.value.length;
      }
    }
  }
</script>

<style lang="scss">


    .styled-options {

        &__group {
            padding: 0.5em 0;
            display: flex;
        }

        &__option {

            &--error {
                color: red;
            }
        }
    }

    .invisible {
        width: 0;
        height: 0;
        padding: 0;
        margin: 0;
        overflow: hidden;
    }

    /* radio buttons */
    .field-radio {
    }

    .radio__label {
    }

    .styled-options__option {
        padding: 0.25em 1em;
        display: flex;
        align-items: center;
    }

    .styled-options__input,
    .styled-options__label {
        margin-left: .5em;
        cursor: pointer;

    }

    .radio__group {
        display: flex;
    }

    /* rowfield radio */
    .radio__option-label {
        cursor: pointer;
        color: #AAA;
        font-weight: 400;
        font-size: 1em;
        border: 0;
        padding: 0.5em 0 0.5em 0.5em; /* margin-left: -1rem; */
        margin-right: 1.5em;
    }

    .radio__option-label--active {
        background-color: transparent;
        color: black;
    }

    .radio__option-label::after {
        transition: all 0.2s ease;
        content: '\2714';
        display: inline-block;
        transform: scale(0.5);
        opacity: 0;
        margin-left: 0.5em;
    }

    .radio__option-label--active::after {
        opacity: 1;
        content: '\2714';
        transform: scale(0.7);
        transform-origin: center;
        color: #00bb00;
    }

    .radio-standalone__option-label {
        font-weight: 500;
        margin: 0;
        cursor: pointer;
        padding: 0.7em 1.5em;
        font-size: 1.2em;
        max-width: none;
        display: inline-block;
        color: #737373;
        border: 0 solid #DEDEDE;
        border-width: 0.05em 0.05em 0.05em 0;
        background-color: white;
        transition: all 0.2s ease;
    }

    .radio-standalone__option-label:nth-child(2) {
        border-radius: 0.25em 0 0 0.25em;
        border-width: 0.05em
    }

    .radio-standalone__option-label:last-child {
        border-radius: 0 0.25em 0.25em 0;
        border-width: 0.05em 0.05em 0.05em 0
    }

    .radio-standalone__option-label--active {
        background-color: #0086DF;
        border-color: #0086DF;
        color: white;
    }

    .radio-standalone__option-label::after {
        display: none;
    }

    /* checkbox */
    .checkbox__option-input {
        width: 0;
        height: 0;
        padding: 0;
        margin: 0;
    }

    .radio__label {
    }

    .checkbox__group {
        display: flex;
    }

    .checkbox__option-label {
        cursor: pointer;
        color: #AAA;
        font-weight: 400;
        font-size: 1em;
        border: 0;
        padding: 1.3em 0 1.3em 0em; /* margin-left: -1rem; */
        margin-right: 2.5em;
    }

    .checkbox__option-label--active {
        background-color: transparent;
        color: black;
    }

    .checkbox__option-label::after {
        transition: all 0.2s ease;
        content: '\2714';
        display: inline-block;
        transform: scale(0.4);
        opacity: 0;
        padding-left: 0.5em;
    }

    .checkbox__option-label--active::after {
        opacity: 1;
        transform: scale(0.7);
        transform-origin: center;
        color: #00bb00;
    }

    /* special colors for net type */
    .clu-net-type-radio__option-label:nth-child(2) {
        color: #00a0ff;
    }

    .clu-net-type-radio__option-label:nth-child(4) {
        color: #e80000;
    }

    /* radio standalone */
    .radio-standalone {
        padding-top: 0;
        border-bottom: 0;
    }

    .checkbox__option-label--disabled,
    .radio__option-label--disabled {
        display: none;
    }

    .checkbox__option-label--disabled.checkbox__option-label--active,
    .radio__option-label--disabled.radio__option-label--active {
        color: #3d7171;
        font-weight: 400;
        display: block;
        background-color: white;
    }

    .foa__input--disabled {
    }
</style>